export default "__VITE_ASSET__b3080f5c__"